import { CurrencyType } from "@lib/titan2/dist/api/common/controller/net/constant/Constants";
import { BalanceResponseData } from "@lib/titan2/dist/api/common/controller/net/response/data/BalanceResponseData";
import { Balance } from "@lib/titan2/dist/api/common/model/data/Balance";
import { BalanceManager } from "@lib/titan2/dist/api/common/model/data/BalanceManager";
import { ClientData } from "@lib/titan2/dist/api/common/model/data/ClientData";
import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { GameProgressData } from "../model/data/GameProgressData";
import { GameState } from "../model/enum/GameState";
import { SlingoConstants } from "../model/enum/SlingoConstants";
/**
 * PurchaseEntryResponseData.ts
 */
export class PurchaseEntryResponseData extends SolidifyableData {
    solidify() {
        super.solidify();
        if (this.isSuccess()) {
            BalanceManager.getInstance().resetWin();
            this.gameId = this.data.getNumber(SlingoConstants.PROPERTY_GAME_ID);
            this.gameInstanceId = this.data.getNumber(SlingoConstants.PROPERTY_GAME_INSTANCE_ID);
            this.state = GameState.getState(this.data.getString(SlingoConstants.PROPERTY_STATE));
            this.solidifyProgress();
            this.solidifyBalance();
            this.solidifyClient();
        }
    }
    solidifyProgress() {
        let progressData = this.data.getDataObject(SlingoConstants.PROPERTY_GAME_PROGRESS);
        if (this.dataExists(progressData)) {
            this.progress = new GameProgressData(progressData);
        }
    }
    solidifyBalance() {
        const balanceData = new BalanceResponseData(this.data);
        balanceData.solidify();
        const balanceManager = BalanceManager.getInstance();
        this.balance = new Balance(balanceManager.getTotalBalance(), balanceManager.getCurrency(), CurrencyType.CASH, balanceManager.getCashBalance(), balanceManager.getBonusBalance());
    }
    solidifyClient() {
        let clientData = this.data.getDataObject(SlingoConstants.PROPERTY_CLIENT);
        if (this.dataExists(clientData)) {
            this.client = new ClientData(clientData);
        }
    }
    getGameId() {
        return this.gameId;
    }
    getGameInstanceId() {
        return this.gameInstanceId;
    }
    getState() {
        return this.state;
    }
    getGameProgress() {
        return this.progress;
    }
    getBalance() {
        return this.balance;
    }
    getClient() {
        return this.client;
    }
    hasClient() {
        return this.client != null;
    }
}
//# sourceMappingURL=PurchaseEntryResponseData.js.map